import Vue from "vue";
import Router from "vue-router";
import goTo from "vuetify/es5/services/goto";
import store from "./store/store";
Vue.use(Router);

const router = new Router({
  mode: "hash",
  base: process.env.BASE_URL,
  // This is for the scroll top when click on any router link
  scrollBehavior: (to, from, savedPosition) => {
    let scrollTo = 0;

    if (to.hash) {
      scrollTo = to.hash;
    } else if (savedPosition) {
      scrollTo = savedPosition.y;
    }

    return goTo(scrollTo);
  },
  // This is for the scroll top when click on any router link
  routes: [
    {
      path: "/",
      redirect: "resumen",
      component: () => import("@/layouts/full-layout/Layout"),
      
      children: [
        {
          name: "CMI",
          path: "cmi",
          component: () => import("@/views/CMI"),
        },
        {
          name: 'Indicadores',
          path: 'indicadores',
          component: () => import('@/views/Indicadores'),
        },
        {
          name: 'Monitoreo',
          path: 'Monitoreo',
          component: () => import('@/views/Monitoreo'),
        },
        {
          name: 'Medicamentos',
          path: 'medicamentos',
          component: () => import('@/views/Medicamentos'),
        },
      ],
    },
    {
      name: "Resumen",
      path: "/resumen",
      component: () => import("@/layouts/blank-layout/Blanklayout"),
      children: [
        {
          name: "Inicio",
          path: "/",
          component: () => import("@/views/Resumen"),
        },
        
      ],
    },
    {
      path: "/authentication",
      component: () => import("@/layouts/blank-layout/Blanklayout"),
      children: [
        {
          name: "BoxedLogin",
          path: "boxedlogin",
          component: () => import("@/views/authentication/BoxedLogin"),
        },
        
      ],
    },
    {
      path: "*",
      component: () => import("@/views/authentication/Error"),
    },
  ],
});

import NProgress from "nprogress";

router.beforeResolve((to, from, next) => {
  // If this isn't an initial page load.
  if(to.meta.middleware=="guest"){
    store.dispatch("auth/login1")
    if(store.state.auth.authenticated){
      next()
    }else{
      next({name:"BoxedLogin"})
    }
    next()
  }else{
    next()
  }
});

router.afterEach(() => {
  // Complete the animation of the route progress bar.
  NProgress.done();
});




export default router;
